import type { MutateSelectedFailure } from '../../hooks/useBillingCycles';
import { getHttpStatus } from '../../utils/httpErrorUtils';
import { getBusinessErrorMessage } from '../../utils/apiErrorDetail';

type ShowErrorFn = (title: string, message: string) => void;

export const showVoidBillingCycleFailures = (
  failures: MutateSelectedFailure[],
  showError: ShowErrorFn
) => {
  const first = failures[0];
  const status = getHttpStatus(first?.error);
  const detail = getBusinessErrorMessage(first?.error);
  const failedNames = failures.map(f => f.name).join(', ');

  showError(
    'Some billing cycles failed to void',
    (status === 400 || status === 409) && detail
      ? detail
      : `The following billing cycles could not be updated: ${failedNames}`
  );
};
